module.exports = __webpack_public_path__ + "static/media/new1.b3c89bef.jpg";